import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectDetailNews } from '@containers/DetailNews/selectors';

export const useChangeLanguage = () => {
  const router = useRouter();
  const detailNews = useSelector(selectDetailNews);

  const onChangeLanguage = useCallback(
    async (lang: string, onSuccess?: () => void) => {
      try {
        if (router.pathname === '/tin-tuc/[id]') {
          if (detailNews?.slugs?.[lang]) {
            await router.push(
              {
                pathname: router.pathname,
                query: { id: detailNews.slugs[lang] },
              },
              undefined,
              { locale: lang },
            );
          } else {
            await router.push({ pathname: '/tin-tuc' }, undefined, {
              locale: lang,
            });
          }
        } else {
          await router.push(
            {
              pathname: router.pathname,
              query: router.query,
            },
            undefined,
            { locale: lang },
          );
        }

        if (onSuccess) onSuccess(); // 👈 callback sau khi đổi ngôn ngữ
      } catch (err) {
        console.error('Change language failed', err);
      }
    },
    [router, detailNews?.slugs],
  );

  return useMemo(() => ({ onChangeLanguage }), [onChangeLanguage]);
};
